export const removeAllClassesOver = () => {
    for (let item of document.getElementsByClassName('over')) item.classList.remove('over');
};
